import { useCallback } from 'react';
import { gql } from 'graphql-tag';
import { useMutation } from '@apollo/client';

const BEGIN_RESOURCE_USER_TASK_ASSIGNMENT_BULK_ACTION = gql`
  mutation beginResourceUserTaskAssignmentBulkAction(
    $input: BeginResourceUserTaskAssignmentBulkActionInput!
  ) {
    beginResourceUserTaskAssignmentBulkAction(input: $input)
  }
`;

export const useResourceUserTaskAssignmentBulkAction = ({
  projectId,
  resource,
  textSearch
}) => {
  const [
    beginResourceUserTaskAssignmentBulkAction,
    { loading: isBulkActionInProgress }
  ] = useMutation(BEGIN_RESOURCE_USER_TASK_ASSIGNMENT_BULK_ACTION);

  const handleBulkAssignTasksSubmit = useCallback(async () => {
    const result = await beginResourceUserTaskAssignmentBulkAction({
      variables: {
        input: {
          actionType: 'ASSIGN_TASKS',
          projectId,
          resourceUserId: resource.id,
          taskFilter: textSearch ? { textSearch } : null
        }
      }
    });

    return result.data.beginResourceUserTaskAssignmentBulkAction;
  }, [
    beginResourceUserTaskAssignmentBulkAction,
    projectId,
    resource.id,
    textSearch
  ]);

  const handleBulkUnassignTasksSubmit = useCallback(async () => {
    const result = await beginResourceUserTaskAssignmentBulkAction({
      variables: {
        input: {
          actionType: 'UNASSIGN_TASKS',
          projectId,
          resourceUserId: resource.id,
          taskFilter: textSearch ? { textSearch } : null
        }
      }
    });

    return result.data.beginResourceUserTaskAssignmentBulkAction;
  }, [
    beginResourceUserTaskAssignmentBulkAction,
    projectId,
    resource.id,
    textSearch
  ]);

  return {
    isBulkActionInProgress,
    handleBulkAssignTasksSubmit,
    handleBulkUnassignTasksSubmit
  };
};
